import { createContext } from "react";

export const OdeUpdateModalContext = createContext();
